module.exports = __webpack_public_path__ + "media/images/image_rights/impact-a7bb5131f61ee5690a4d1c5c714b4292.png";